import React from 'react';

import type { Props } from '@travel/traveler-core/components/Swiper';
import SwiperCore from '@travel/traveler-core/components/Swiper';
import { EMPTY_ARRAY } from '@travel/traveler-core/constants';
import { useTranslation } from '@travel/traveler-core/hooks';

function Swiper({ children = EMPTY_ARRAY, initialSlide = 0, ...props }: Props) {
  const leftButtonLabel = useTranslation({ id: 'Traveler_Common.Alt.Slider_Previous' });
  const rightButtonLabel = useTranslation({ id: 'Traveler_Common.Alt.Slider_Next' });
  return (
    <SwiperCore
      ariaLabelLeftButton={leftButtonLabel}
      ariaLabelRightButton={rightButtonLabel}
      children={children}
      initialSlide={initialSlide}
      {...props}
    />
  );
}

export default Swiper;
